import { render, staticRenderFns } from "./CameraCapture.vue?vue&type=template&id=145d1275&scoped=true&"
import script from "./CameraCapture.vue?vue&type=script&lang=js&"
export * from "./CameraCapture.vue?vue&type=script&lang=js&"
import style0 from "./CameraCapture.vue?vue&type=style&index=0&id=145d1275&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145d1275",
  null
  
)

export default component.exports